var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "transition-group",
        {
          key: _vm.notificationsRenderKey,
          staticClass: "alerts-drawer-wrapper",
          class: {
            "notification-mb-1": _vm.connectionLost,
            "mb-18": _vm.appUpdateAvailable || _vm.soundsDisabled,
          },
          attrs: { name: "alerts-drawer-wrapper", tag: "div" },
        },
        [
          _vm._l(_vm.notificationQueue, function (alert) {
            return [
              _c(
                "v-card",
                {
                  key: alert.id,
                  staticClass: "alerts-snack rounded-lg elevation-8",
                  staticStyle: { "min-width": "288px !important" },
                  attrs: {
                    maxWidth: alert.text.length < 33 ? "300px" : "500px",
                    minWidth: _vm.$vuetify.breakpoint.xsOnly ? "80%" : "350px",
                    color: alert.color,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.alertClicked(alert)
                    },
                  },
                },
                [
                  _c(
                    "v-card-actions",
                    {
                      staticClass: "pl-4 pr-1",
                      staticStyle: { "min-width": "288px !important" },
                    },
                    [
                      _c("p", {
                        staticClass: "mb-0",
                        domProps: { innerHTML: _vm._s(alert.text) },
                      }),
                      _c("p", { staticClass: "mb-0" }, [
                        _vm.link.length
                          ? _c(
                              "a",
                              { attrs: { href: _vm.link, target: "_blank" } },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "pl-1",
                                    class:
                                      _vm.linkColor == "error"
                                        ? "hover-text-error"
                                        : "hover-text-primary",
                                    staticStyle: {
                                      display: "inline-block",
                                      "font-size": "14px",
                                      "padding-bottom": "4px",
                                    },
                                    attrs: { "x-small": "" },
                                  },
                                  [_vm._v("far fa-question-circle")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "grey lighten-3", icon: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.dismiss(alert.id)
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }